import Vue from "vue";
import Vuex from "vuex";
import { account  } from "./account";
import { app  } from "./app";
import { IAppState } from "./app/state";
import { IAccountState } from "./account/state";

Vue.use(Vuex);

export interface IState {
    account: IAccountState;
    app: IAppState;
}

export const store = new Vuex.Store<IState>({
    modules: {
        account,
        app,
    },
});
